import { ScrollBarStates } from './States/scroll.bar';
import * as _ from 'lodash';
import { AppStates } from './States/app.states';
import { AuthStates } from './States/auth.states';
import { DailyRepoStates } from './States/daily.report.states';
import { HomeStates } from './States/home.states';
import { NavBarStates } from './States/nav.bar.states';
import { PropertyDetailStates } from './States/property.detail.states';
import { SocialShareStates } from './States/social.share.states';
import { RifoTamplateStates } from './States/template.state';
import { MapEpicStates } from './States/map.epic.states';
import { EpicNavBarStates } from './States/epic.nav.bar';
import { NewsListStates } from './States/news.list.state';

export namespace MutationsManager {
    export class Manager {
        public mutations: any = {};
        public constructor() { }

        public register(newMutations: any) {
            _.mixin(this.mutations, newMutations);
        }
    }

    export function factory(): Manager {
        const manager = new Manager();
        manager.register({
            increment(state: any) {
                state.count++;
            },
        });
        manager.register(ScrollBarStates.mutations());
        manager.register(AppStates.mutations());
        manager.register(AuthStates.mutations());
        manager.register(DailyRepoStates.mutations());
        manager.register(HomeStates.mutations());
        manager.register(NavBarStates.mutations());
        manager.register(PropertyDetailStates.mutations());
        manager.register(SocialShareStates.mutations());
        manager.register(RifoTamplateStates.mutations());
        manager.register(MapEpicStates.mutations());
        manager.register(EpicNavBarStates.mutations());
        manager.register(NewsListStates.mutations());
        return manager;
    }
}
